var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "i-info",
    d: "M10.562.563a10,10,0,1,0,10,10A10,10,0,0,0,10.562.563Zm0,4.435A1.694,1.694,0,1,1,8.869,6.692,1.694,1.694,0,0,1,10.562,5ZM12.821,15.24a.484.484,0,0,1-.484.484H8.788A.484.484,0,0,1,8.3,15.24v-.968a.484.484,0,0,1,.484-.484h.484V11.208H8.788a.484.484,0,0,1-.484-.484V9.756a.484.484,0,0,1,.484-.484h2.581a.484.484,0,0,1,.484.484v4.032h.484a.484.484,0,0,1,.484.484Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#c4c4c4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIInfo);
export default __webpack_public_path__ + "static/media/i-info.ba5095bf.svg";
export { ForwardRef as ReactComponent };